<template>
  <div>
    <div class="dept-box">
      <div class="exam-select">
        <div class="button-box">
          <el-button
            type="info"
            :plain="zuobtn"
            @click="btnDepartmentList()"
            size="small"
            class="item"
          >部门人员列表</el-button>

          <el-badge :value="ExaminersTableAll.length" class="item">
            <el-button
              style="margin: 0 10px"
              type="info"
              :plain="youbtn"
              @click="btnSelectedExam()"
              size="small"
            >已选考试人员</el-button>
          </el-badge>
        </div>
        <div class="info-box">
          <div class="contain-box">
            <div class="img-box">
              <img src="@/assets/exam/u12442.png" />
            </div>
            <div class="text-box">
              <span style="font-weight: 700">培训班总人数</span>
              <span>{{ peopleNum.SumNum }}人</span>
            </div>
          </div>
          <div class="contain-box">
            <div class="img-box img2">
              <img src="@/assets/exam/signup-1.png" />
            </div>
            <div class="text-box">
              <span style="font-weight: 700">已报名</span>
              <span>{{ peopleNum.BmNum }}人</span>
            </div>
          </div>
          <div class="contain-box">
            <div class="img-box img3">
              <img src="@/assets/exam/u12441.png" />
            </div>
            <div class="text-box">
              <span style="font-weight: 700">下发部门</span>
              <span>{{ peopleNum.DeptPeoNum }}个</span>
            </div>
          </div>
          <div class="contain-box">
            <div class="img-box img4">
              <img src="@/assets/exam/u12439.png" />
            </div>
            <div class="text-box">
              <span style="font-weight: 700">下发部门人数</span>
              <span>{{ peopleNum.DeptNum }}人</span>
            </div>
          </div>
        </div>
      </div>
      <div class="trainStaff-addbox" v-if="zuo">
        <div class="depttree-box">
          <div class="department">
            <eltrees @childerdepartment="childerdepartment" :parentIdOne="parentIdOne"></eltrees>
          </div>
        </div>
        <div class="select-box">
          <div class="addAll">
            <el-radio v-model="listQuery.isChild" :label="true" @change="handleSearch()">显示子部门人员</el-radio>
            <el-radio v-model="listQuery.isChild" :label="false" @change="handleSearch()">仅显示当前部门人员</el-radio>
            <el-button type="primary" size="small" @click="addPeople()" icon="el-icon-plus">添加</el-button>
            <!-- <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              @click="batchImport"
              style=" margin: 0 20px"
              >导入人员</el-button
            >-->
            <div class="input-box">
              <el-input
                v-model="listQuery.name"
                placeholder="请输入姓名"
                size="small"
                clearable
                @change="handleSearch()"
                style="margin: 0 10px"
              ></el-input>

              <el-button
                type="primary"
                size="small"
                @click="handleSearch()"
                icon="el-icon-search"
              >搜索</el-button>
            </div>
          </div>
          <el-table
            :data="AllExaminersTable"
            border
            height="405"
            style="width: 98%"
            :row-style="selectedHighlight"
            :cell-style="{ 'text-align': 'center' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              align="center"
              type="index"
              min-width="50"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              min-width="150"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              align="center"
              min-width="150"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.sex == true">男</span>
                <span v-if="scope.row.sex == false">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="code"
              label="警号"
              align="center"
              min-width="200"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="deptName"
              label="所在单位"
              align="center"
              min-width="200"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="handleCurrentUser"
            style="width: 98%"
          />
        </div>
      </div>
      <div class="select-box" v-if="you">
        <div class="addAll">
          <el-button type="danger" size="small" @click="deleteAll()" icon="el-icon-delete">删除</el-button>
          <div class="input-box">
            <el-input
              v-model="listQuery2.userName"
              placeholder="请输入姓名"
              size="small"
              clearable
              @change="getAlreadyUser()"
              style="margin: 0 10px"
            ></el-input>
            <el-button type="primary" size="small" @click="getAlreadyUser()">搜索</el-button>
          </div>
        </div>
        <el-table
          :data="ExaminersTable"
          border
          height="405"
          style="width: 98%"
          @selection-change="handleSelectionChangeAlready"
          :row-style="selectedHighlight"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column align="center" type="index" min-width="50" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column
            prop="name"
            show-overflow-tooltip
            label="姓名"
            align="center"
            min-width="150"
          ></el-table-column>
          <el-table-column prop="sex" label="性别" align="center" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == true">男</span>
              <span v-if="scope.row.sex == false">女</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            label="警号"
            show-overflow-tooltip
            align="center"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="deptname"
            label="所在单位"
            show-overflow-tooltip
            align="center"
            min-width="200"
          ></el-table-column>
        </el-table>
        <!-- <pagination
          v-show="total2 > 0"
          :total="total2"
          :page.sync="listQuery2.page"
          :limit.sync="listQuery2.limit"
          @pagination="handleCurrentUser2"
          style="width: 98%"
        />-->
      </div>
    </div>
    <div v-if="zdDepartment">
      <div class="title1">
        <span>当前考试为指定部门报名，请设置报名部门！</span>
      </div>
      <div style="display: flex">
        <div style="padding-left: 50px">
          <div class="department">
            <el-input placeholder="请输入关键字" v-model="filterText" style="width: 270px"></el-input>
            <eltrees @childerdepartment="childerdepartment"></eltrees>
          </div>
        </div>
        <div style="padding-left: 50px">
          <el-table
            :data="DepartmentTable"
            border
            height="440"
            style="width: 100%; margin-top: 20px"
            @selection-change="handleSelectionChange2"
          >
            <el-table-column type="selection" align="center" min-width="50"></el-table-column>
            <el-table-column fixed prop="Name" label="单位名称" align="center" min-width="400"></el-table-column>
            <el-table-column prop="Count" label="单位人数" align="center" min-width="200"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 导入人员 -->
    <el-dialog
      title="提示"
      top="10vh"
      :visible.sync="batchDialogVisible"
      width="30%"
      destroy-on-close
      :before-close="batchHandleClose"
    >
      <div v-if="batchDialogVisible">
        <el-form ref="formRef" :model="form" label-width="100px">
          <el-form-item label="模板下载:">
            <el-button
              size="small"
              type="text"
              @click="download"
              style="text-decoration: underline"
            >模板例子</el-button>
          </el-form-item>
          <el-form-item label="文件导入:">
            <el-upload
              :headers="headers"
              :on-change="onChange"
              class="upload-demo"
              drag
              :auto-upload="false"
              :action="url"
              accept=".xls, .xlsx"
              ref="fileTemplete"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击导入</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能导入.xls, .xlsx文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div v-show="flag">
          <span>
            成功导入{{ outputs.realCount }}名参训人员，导入失败{{
            outputs.errorCount
            }}名参训人员
          </span>
          <el-table
            :data="outputs.erorList"
            height="200"
            :cell-style="{ 'text-align': 'center' }"
            style="width: 100%"
          >
            <el-table-column prop="key" label="身份证号码" width="180"></el-table-column>
            <el-table-column prop="name" label="姓名" width="180"></el-table-column>
            <el-table-column prop="mes" label="错误原因"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="upFile">确 定 导 入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import eltrees from '@/components/Eltree'; //部门树形结构异步加载
import Pagination from '@/components/Pagination'; //分页
import { getList, SelectExamUser, BatchAddition } from '@/api/exam/addks';
import * as apiTrain from '@/api/train/trainPeople';
import * as apiTrainTask from '@/api/train/trainTask';

export default {
  props: ['trainId'],
  components: {
    eltrees,
    Pagination,
  },
  data() {
    return {
      flagJia: true,
      addShow: null,
      listQuery: {
        //数的查询条件
        page: 1,
        limit: 20,
        deptId: 2,
        userName: null,
        userCode: null,
        idCard: null,
        detpName: null,
        ObjType: 3,
        ObjId: 0,
        isChild: true,
      },
      listQuery2: {
        //数的查询条件
        page: 1,
        limit: 20,
        trainId: parseInt(sessionStorage.getItem('trainId')),
        userName: null,
        userCode: null,
        idCard: null,
        detpName: null,
      },
      zuo: true,
      you: false,
      zuobtn: false,
      youbtn: true,
      zdUser: false,
      zdDepartment: false,
      ExaminersTable: [],
      ExaminersTableAll:[],
      AllExaminersTable: [],
      total: 0,
      total2: 0,
      alreadyExam: true,
      filterText: '',
      DepartmentTable: [
        {
          Name: '深圳市交警大队一中队',
          Count: '35',
        },
        {
          Name: '深圳市交警大队二中队',
          Count: '45',
        },
        {
          Name: '深圳市交警大队三中队',
          Count: '30',
        },
        {
          Name: '广州市交警大队一中队',
          Count: '40',
        },
        {
          Name: '广州市交警大队二中队',
          Count: '50',
        },
      ],
      examId: 0,
      pageIndex: 1,
      pageSize: 20,
      batchDialogVisible: false,
      form: null,
      url: '/api/TrainPeople/Import?',
      fileData: '', // 保存选择的文件数据
      excelAddress: '',
      outputs: {}, // 保存读取出来的数据列表
      flag: false,
      deleteList: [],
      parentIdOne: 2,
      peopleNum: {},
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  created() {
    this.parentIdOne = JSON.parse(this.$store.state.User.infos).deptId;
    if (this.trainId) {
      this.listQuery2.trainId = this.trainId;
      this.listQuery.ObjId = this.trainId;
      this.getAlreadyUser()
      // this.getTaskPeople();
      this.getTaskDeptCount();
    }
  },
  methods: {
    //获取报名的人数和报送单位的人数
    getTaskDeptCount() {
      let para = {
        trainId: this.trainId,
        deptId: JSON.parse(this.$store.state.User.infos).deptId,
      };
      apiTrainTask.getTaskDeptCount(para).then((res) => {
        this.peopleNum = res.result;
      });
    },
    getTaskPeople() {
      let para = {
        trainId: this.trainId,
        deptId: JSON.parse(this.$store.state.User.infos).deptId,
      };
      apiTrainTask.getTaskPeople(para).then((res) => {
        this.ExaminersTable = res.result;
      });
    },
    //获取已加入的用户
    getAlreadyUser() {
      this.listQuery2.trainId = this.trainId;
      this.listQuery2.detpName = JSON.parse(
        this.$store.state.User.infos
      ).deptName;
      apiTrain.getUserList(this.listQuery2).then((res) => {
        this.ExaminersTable = res.data;
        this.total2 = res.count;
      });
      let para={
        page: 1,
        limit: 1000,
        trainId: this.trainId,
      }
      apiTrain.getUserList(para).then((res) => {
        this.ExaminersTableAll= res.data;

      });
    },
    //选中要删除的人员
    handleSelectionChangeAlready(val) {
      this.deleteList = val;
    },
    //选中的人员
    handleSelectionChange(val) {
      this.deleteList = val;
    },
    updatePeople() {
      let data = this.ExaminersTable;
      this.ExaminersTable.forEach((item) => {
        item.createId = parseInt(this.$store.state.User.ids);
        item.trainId = this.trainId;
        item.taskDeptId = JSON.parse(this.$store.state.User.infos).deptId;
      });
      apiTrain.updateUserList(data).then((res) => {
        if (res.code == 200) {
          this.$message.success('修改成功！');
        }
      });
    },
    //加入考试人员
    addPeople() {
      let peopleLength =
        this.deleteList.length +
        this.ExaminersTableAll.length +
        this.peopleNum.DeptNum;
      if (peopleLength > this.peopleNum.SumNum) {
        return this.$message.error('加入的人数不能超过总人数，请重新添加！');
      }
      let list = [];
      this.deleteList.forEach((item) => {
        list.push({
          trainId: this.trainId,
          userId: item.id,
          taskDeptId: JSON.parse(this.$store.state.User.infos).deptId,
          createId: parseInt(this.$store.state.User.ids),
        });
      });
      apiTrain.addUserList(list).then((res) => {
        if (res.code == 200) {
          // this.$message.success("添加成功！")
          this.btnSelectedExam();
          setTimeout(() => {
            for (let i = 0; i < this.AllExaminersTable.length; i++) {
              for (let j = 0; j < this.deleteList.length; j++) {
                if (
                  this.AllExaminersTable[i].idCard == this.deleteList[j].idCard
                ) {
                  this.AllExaminersTable.splice(i, 1);
                }
              }
            }
          }, 300);
          // this.getTaskPeople();
          this.getAlreadyUser()
          this.getTaskDeptCount()
        }
      });
    },
    //文件选择时
    onChange(file, fileList) {
      this.fileData = file; // 保存当前选择文件
      this.excelAddress = URL.createObjectURL(file.raw);
      debugger;
    },
    // 文件下载
    download() {
      let a = document.createElement('a');
      a.setAttribute('download', '模板例子');
      a.setAttribute('target', '_blank');
      a.setAttribute('href', '/uploadfile/train_people.xls');
      a.click();
    },
    //确认上传excel
    upFile() {
      let _this = this;

      if (_this.$refs.fileTemplete.uploadFiles.length > 0) {
        let formData = new FormData();
        formData.append(
          'publicFile',
          _this.$refs.fileTemplete.uploadFiles[0].raw
        );
        _this.url = '/api/TrainPeople/Import?';
        _this.url = `${_this.url}trainId=${parseInt(
          sessionStorage.getItem('trainId')
        )}`;
        apiTrain.importPeople(_this.url, formData).then((res) => {
          if (res.code !== 200) {
            this.$message.error('上传失败！');
          } else {
            _this.$message.success('上传成功');
            _this.outputs = res.result;
            this.flag = true;
          }
        });
      }
    },
    //关闭
    batchHandleClose() {
      this.batchDialogVisible = false;
    },
    //批量导入
    batchImport() {
      this.batchDialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentUser(val) {
      debugger;
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getUser();
    },
    handleCurrentUser2(val) {
      this.listQuery2.page = val.page;
      this.listQuery2.limit = val.limit;
      // this.getTaskPeople();
      this.getAlreadyUser()
    },
    selectedHighlight({ row }) {
      if (row.status == true) {
        return {
          'background-color': '#409EFF',
        };
      }
    },
    //点击添加
    TJBatchAddition() {
      this.AllExaminersTable.forEach((item, index) => {
        this.ExaminersTable.push(item);
        setTimeout(() => {
          this.AllExaminersTable.splice(index);
        }, 500);
      });
      this.quChong(this.ExaminersTable);
    },
    quChong(ExaminersTable) {
      //去重
      let newArr = ExaminersTable.filter((x, index, self) => {
        let arrids = [];
        ExaminersTable.forEach((item, i) => {
          arrids.push(item.id);
        });
        const ret = arrids.indexOf(x.id) === index;
        return ret;
      });
      this.ExaminersTable = newArr;
    },
    getUser() {
      getList(this.listQuery).then((response) => {
        this.AllExaminersTable = response.data;
        if (this.ExaminersTableAll.length > 0) {
          let newArr = this.AllExaminersTable.filter((item) => {
            // 将arr的所有id集合的数组赋值给临时数组,
            //map()会返回一个新数组,并且不会影响原数组
            let arrlist = this.ExaminersTableAll.map((item2) => item2.idcard);
            // 返回所有临时数组中没有item.id的item
            return !arrlist.includes(item.idCard);
          });
          this.AllExaminersTable = newArr;
        }
        this.total = response.count;
      });
    },
    handleSearch() {
      this.getUser();
    },
    //删除已选考试人员
    deleteAll() {
      apiTrain.deleteUserList(this.deleteList.map((u) => u.id)).then((res) => {
        if (res.code == 200) {
          // this.$message.success("删除成功！")
          // this.getTaskPeople();
          this.getAlreadyUser()
          this.getTaskDeptCount()
        }
      });
    },
    childerdepartment(val) {
      this.listQuery.deptId = val;
      this.getUser();
    },
    //点击部门人员列表
    btnDepartmentList() {
      this.zuo = true;
      this.you = false;
      this.alreadyExam = true;
    },
    //点击已选考试人员
    btnSelectedExam() {
      this.zuo = false;
      this.you = true;
      this.alreadyExam = false;
      // this.listQuery.isChild = false;
    },
    //添加考试人员
    jia(data, index) {
      this.flagJia = false;
      this.addShow = index;
      setTimeout(() => {
        this.addShow = null;
        this.flagJia = true;
      }, 1000);
      let newData = {
        code: data.code,
        deptName: data.deptName,
        id: data.id,
        idCard: data.idCard,
        name: data.name,
        sex: data.sex,
        taskDeptId: data.taskDeptId,
        trainId: data.trainId,
        userId: data.id,
      };
      this.ExaminersTable.push(newData);
      setTimeout(() => {
        for (let i = 0; i < this.AllExaminersTable.length; i++) {
          if (this.AllExaminersTable[i].name == data.name) {
            this.AllExaminersTable.splice(i, 1);
          }
        }
      }, 300);
      //去重
      let newArr = this.ExaminersTable.filter((x, index, self) => {
        let arrids = [];
        this.ExaminersTable.forEach((item, i) => {
          arrids.push(item.id);
        });
        const ret = arrids.indexOf(x.id) === index;
        return ret;
      });
      this.ExaminersTable = newArr;
    },
    jian(index) {
      for (let i = 0; i < this.ExaminersTable.length; i++) {
        if (this.ExaminersTable[i].name == index.name) {
          this.ExaminersTable.splice(i, 1);
        }
      }
    },
  },
  watch: {
    zuo: {
      handler() {
        if (this.zuo == true) {
          this.zuobtn = false;
          this.youbtn = true;
        }
      },
    },
    you: {
      handler() {
        if (this.you == true) {
          this.youbtn = false;
          this.zuobtn = true;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.dept-box {
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(226, 223, 223);
  padding: 20px;
  .depttree-box {
    margin-top: 60px;
    border: 1px solid rgb(226, 223, 223);
    border-radius: 3px;
    width: 300px;
    padding: 10px;
    overflow: auto;
    max-height: 450px;
    .title-text {
      font-size: 20px;
      font-weight: 700;
    }
    .department {
      // margin-top: 20px;
    }
  }
  .select-box {
    padding: 0 20px;
    width: 100%;
    .exam-select {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 150px;
      }
      .button-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 20%;
      }
      .input-box {
        display: flex;
        width: 600px;
      }
    }
    .addAll {
      padding: 10px;
      display: flex;
      height: 60px;
      justify-content: flex-end;
      align-items: center;
      .input-box {
        display: flex;
      }
    }
  }
}

.add_img {
  font-size: 22px;
  background-color: aqua;
}
.shop_cart-enter-active {
  transition: all 1s ease-out;
}

.shop_cart-enter {
  opacity: 0;
  transform: scale(1.5);
  // transform: translate(-100px, 200px);
}
.add:hover {
  background-color: #02a7f0;
  border-radius: 50%;
}
.trainStaff-addbox {
  display: flex;
}

.exam-select {
  display: flex;
  justify-content: space-between;
}
.info-box {
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .contain-box {
    width: 200px;
    display: flex;
  }
  .img-box {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../../../../assets/exam/u12419.svg');
    border-radius: 50%;
    background-repeat: no-repeat;
    zoom: 0.8;
  }
  .img2 {
    background-image: url('../../../../assets/exam/signup-2.svg');
  }
  .img4 {
    background-image: url('../../../../assets/exam/signup-6.svg');
  }
  .img3 {
    background-image: url('../../../../assets/exam/signup-8.svg');
  }
  .img5 {
    background-image: url('../../../../assets/exam/signup-9.svg');
  }
  .text-box {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding: 0 10px;
    line-height: 20px;
  }
  img {
    width: 36px;
    height: 36px;
  }
}
</style>